import { Grid, Typography } from '@material-ui/core';

const SubscriptionQuote = (props) => {
  const { classes, renewalCycleText, renewalCycleValue } = props;
  return (
    <Grid item container className={classes.subscriptionQuoteItemContainer}>
      <Grid
        item
        className="subscription-quote-renewal-cycle-text"
        xs={12}
        sm={6}
      >
        <Typography>{renewalCycleText}</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography className={classes.semiBold}>
          {renewalCycleValue}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SubscriptionQuote;
